<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    style="width: 350px"
    placeholder="Pilih Toko"
    allow-clear
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
  >
    <a-select-option
      v-for="d in filteredData"
      :key="d.customer_code"
      :label="`${d.customer_code} - ${d.customer_name}`"
    >
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(`${d.customer_code} - ${d.customer_name}`)"></span>
      <!-- eslint-enable -->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, watch, computed } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'

export default {
  name: 'FilterToko',
  props: {
    value: {
      default: () => [],
      type: Array,
    },
    salesman: {
      type: [String, Number, Array],
      default: null,
    },
  },
  emits: ['update:value'],
  setup(props) {
    const data = ref([])
    const findText = ref(null)
    const valueState = useVModel(props, 'value')

    /** 🔹 Ambil data toko berdasarkan salesman */
    const fetchData = async () => {
      if (!props.salesman) return
      try {
        const response = await apiClient.get(`/api/users-salesman/customers/${props.salesman}`)
        // ambil field yang dibutuhkan saja
        data.value = response.data.items.map(item => ({
          customer_id: item.customer_id,
          customer_code: item.customer_code,
          customer_name: item.customer_name,
        }))
      } catch (error) {
        console.error('Gagal memuat data toko:', error)
      }
    }

    onMounted(fetchData)
    watch(() => props.salesman, fetchData)

    const onSearch = val => {
      findText.value = val
    }

    /** 🔹 Fungsi highlight teks pencarian */
    const highlight = val => {
      if (!findText.value) return val
      return val.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }

    /** 🔹 Filter hasil pencarian */
    const filteredData = computed(() => {
      if (!findText.value) return data.value
      return data.value.filter(d =>
        (`${d.customer_code} - ${d.customer_name}`)
          .toLowerCase()
          .includes(findText.value.toLowerCase()),
      )
    })

    return {
      data,
      filteredData,
      valueState,
      findText,
      onSearch,
      highlight,
    }
  },
}
</script>
